import apiClient, { unwrap } from './client'
import type { InboundRule, WebhookHeader } from './types'

export interface InboundRuleInput {
  domain: string
  target_url: string
  enabled?: boolean
  format?: string // json / multipart
  /** 自定义请求头（值可含 ${var} 占位符） */
  headers?: WebhookHeader[]
  /** 请求体模板（含 ${var} 占位符，json 格式下渲染后发送；空则用默认结构） */
  body_template?: string
}

export const inboundApi = {
  list() {
    return unwrap<InboundRule[]>(apiClient.get('/inbound-rules'))
  },
  create(input: InboundRuleInput) {
    return unwrap<{ id: number; domain: string; format: string }>(
      apiClient.post('/inbound-rules', input),
    )
  },
  update(id: number, input: InboundRuleInput) {
    return unwrap<{ id: number; updated: boolean }>(
      apiClient.put(`/inbound-rules/${id}`, input),
    )
  },
  remove(id: number) {
    return unwrap<{ deleted: number }>(apiClient.delete(`/inbound-rules/${id}`))
  },
}